<template>
  <div
    id="app_menu"
    class="reserved d-flex justify-content-center align-items-center">

    <div class="container">
      <div id="menu-content" class="menu-content">
        <div id="menu-nav" class="menu-nav">
          <div class="w-element-menu">
            <div class="logo">
              <div class="wrap-logo w-image">
                <a :href="url('/b2b')">
                  <img
                    :src="url('/media/icons/svg/logo4-belt.svg')"
                    alt="Logo 4-Belt"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="w-element-menu links-menu desktop">
            <div class="w-link-list">
              <ul>
                <li
                  class="option d-flex"
                  :class="{ active: isActiveMenu('product') }"
                  @click="onClickMenuNav('product')"
                >
                  {{ trans.get("b2b.menu.products") }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 14 7">
                    <path id="Fill_1" data-name="Fill 1" d="M13.564,0,7,6.179.437,0,0,.41,7,7,14,.41Z" fill="#fff"/>
                  </svg>
                </li>
                <li>
                  <a href="#contact-us">{{
                    trans.get("b2b.menu.contact-us")
                  }}</a>
                </li>
                <!-- <li>Promozioni</li> -->
                <li><lang-selector /></li>
              </ul>
            </div>
          </div>

          <div
            v-if="mobile_menu === true"
            class="w-element-menu links-menu mobile"
          >
            <div class="w-link-list">
              <ul>
                <li
                  class="option d-flex"
                  :class="{ active: isActiveMenu('product') }"
                  @click="onClickMenuNav('product')"
                >
                  {{ trans.get("b2b.menu.products") }}
                </li>
                <li><a href="#contact-us">{{ trans.get("b2b.menu.contact-us") }}</a></li>
                <!-- <li>Promozioni</li> -->
                <li class="v-seselct-lang"><lang-selector/></li>
              </ul>
            </div>
          </div>

          <div class="w-element-menu">
            <ul class="w-icons justify-content-between">
              <li
                v-for="(icon, i) in icons"
                :key="i"
                class="icon"
                @click="onClickMenuNav(icon.action)"
              >
                <img :src="url(icon.img)" :alt="icon.alt" />
                <div
                  v-if="icon.action === 'cart' && numCartItems > 0"
                  class="badge-cart"
                >
                  {{ numCartItems }}
                </div>
              </li>

              <li class="icon hamburger" @click="mobile_menuOn()">
                <img src="/media/icons/png/hamburger-white.png" alt="menu" />
              </li>
            </ul>
          </div>

          <div class="w-element-menu">
            <ul class="w-logout">
              <li class="">
                <a class="size-09 pointer red d-flex" @click="logout()">
                  <img src="/media/icons/svg/logout-red.svg" alt="logout" />

                  <span class="ml-4 text">Log Out</span>
                </a>
              </li>
            </ul>
          </div>

          <transition name="menunavfloat">
            <div
              v-show="opened_menu_nav"
              id="menu-nav-float"
              class="menu-nav-float"
              :class="mobile_menu ? 'product' : ''"
            >
              <!-- CLICK PRODOTTI -->
              <div
                v-show="isActiveMenu('product')"
                class="float-block product"
                v-if="tree"
              >
                <div class="container">
                  <ul>
                    <!-- MENU MACROFAMIGLIE -->
                    <li
                      class="d-flex align-items-baseline level-zero"
                      :class="macro.code === macro_menu ? 'noFreccia' : ''"
                      v-for="macro in tree"
                      v-if="macro.codice !== 'sep' && macro.codice !== 'MP'"
                    >
                      <a :href="url('/b2b/macrofamily-article/' + macro.codice)" v-if="macro.codice !== 'CIN' && macro.codice !== 'NAS'">
                        <span @mouseenter="articleDrop(-1, 'macro')" class="level-one macro-caps" v-if="macro.codice === '4TOOLS'">
                          4-Tools
                        </span>
                        <span  @mouseenter="articleDrop(-1, 'macro')" class="level-one macro-caps" v-if="macro.codice === '4CLEAN'">
                          4-Clean
                        </span>
                        <span   @mouseenter="articleDrop(-1, 'macro')" class="level-one macro-caps" v-if="macro.codice === '4CUSTOM'">
                          4-Custom
                        </span>
                        <span  @mouseenter="articleDrop(-1, 'macro')" class="level-one macro-caps" v-if="macro.codice === 'ENG'">
                          4-Engeneering
                        </span>
                      </a>
                      <a @mouseenter="articleDrop(macro.codice, 'macro')"
                         @click.stop="articleDropMacroClick(macro.codice)"
                         v-if="macro.codice === 'CIN' || macro.codice === 'NAS'"

                        class="my-caps" >

                        <span class="level-one" v-if="macro.codice ==='CIN' || macro.codice === 'NAS'">
                          {{ macro.descrizione }}
                        </span>
                      </a>

                      <!-- MENU FAMIGLIE -->
                      <ul
                        v-if="macro.codice === macro_menu"
                        class="sottomenu families d-flex flex-column"
                      >
                        <!-- TITOLO SOTTOMENU -->
                        <!-- <b-skeleton :active="loading" :animated="animated"></b-skeleton> -->

                        <li class="link-ret noFreccia px16">
                          <i
                            v-if="width < 768"
                            @mouseenter="articleDrop(macro.codice, 'macro')"
                            @click="articleDropMacroClick('')"
                            class="fas fa-angle-double-left"
                          ></i>

                          <a :href="url('/b2b/macrofamily-article/' + macro.codice) " class="my-caps macrofamiglie" >
                            <span class="level-two macro-caps" v-if="macro.codice === '4TOOLS'">
                          4-Tools
                        </span>
                            <span class="level-two macro-caps" v-if="macro.codice === '4CLEAN'">
                          4-Clean
                        </span>
                            <span class="level-two macro-caps" v-if="macro.codice === '4CUSTOM'">
                          4-Custom
                        </span>
                            <span class="level-two" v-else-if="macro.codice ==='CIN' || macro.codice === 'NAS' || macro.codice==='ENG'">
                          {{ macro.descrizione }}
                        </span>
                          </a>
                        </li>

                        <!-- CICLO FAMIGLIE -->

                        <li
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            link-ret
                          "
                          :style="
                            famiglia.codice === family_menu
                              ? 'background-color: #f6f6f6;'
                              : ''
                          "
                          v-for="(famiglia, i) in macro.famiglie"
                          :key="i"
                          v-if="
                            (famiglia.categorie &&
                              famiglia.categorie.length > 0) ||
                            (famiglia.microfamiglie &&
                              famiglia.microfamiglie.length > 0)
                          "
                        >
                          <a
                            @mouseenter="articleDrop(famiglia.codice, 'family')"
                            @click="articleDropFamilyClick(famiglia.codice)"
                            class="
                              my-caps
                              d-flex
                              align-items-center
                              justify-content-between
                              flex-nowrap
                            "
                          >
                            <div class="sx">
                              <img
                                class="icon"
                                :src="
                                  url(
                                    '/storage/media/icons/svg/family/black/' +
                                      famiglia.codice
                                        .replace('+', 'plus')
                                        .toLowerCase() +
                                      '.svg'
                                  )
                                    ? url(
                                        '/storage/media/icons/svg/family/black/' +
                                          famiglia.codice
                                            .replace('+', 'plus')
                                            .toLowerCase() +
                                          '.svg'
                                      )
                                    : 'https://via.placeholder.com/300.png'
                                "
                                alt=""
                              />

                              <!-- <img
                            v-else="famiglia.codice"
                            class="icon"
                            src="https://via.placeholder.com/300.png"
                            alt=""
                          /> -->

                              <span>{{ famiglia.descrizione }}</span>
                            </div>
                            <img
                              class="freccina dx"
                              src="/media/icons/svg/freccina.svg"
                              alt=""
                            />
                          </a>
                        </li>

                        <!-- MENU MICROFAMIGLIE/CATEGORIE-->
                        <ul
                          v-for="famiglia in macro.famiglie"
                          v-if="famiglia.codice === family_menu"
                          class="sottomenu micros d-flex flex-column"
                          :style="microStyle"
                        >
                          <!-- TITOLO SOTTOMENU -->
                          <li
                            :style="
                              famiglia.codice == family_menu
                                ? 'background-color: #f6f6f6;'
                                : ''
                            "
                            class="
                              d-flex
                              justify-content-between
                              align-items-center
                              red
                              noFreccia
                              link-ret
                              px16
                            "
                          >
                            <i
                              v-if="width < 768"
                              @mouseenter="articleDrop(famiglia.codice, 'family')"
                              @click="articleDropFamilyClick('')"
                              class="fas fa-angle-double-left"
                            ></i>

                            <a :href="url('/b2b/family/' + famiglia.codice)" class="my-caps" >
                              <span class="level-three">
                                {{ famiglia.descrizione }}</span>
                            </a>
                          </li>

                          <!-- CICLO MICRO SE CI SONO-->
                          <li
                            v-for="micro in famiglia.microfamiglie"
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              link-ret
                            "
                            :style="
                              micro.codice == micro_menu
                                ? 'background-color: #efeeee;'
                                : ''
                            "
                          >
                            <a
                              @mouseenter="articleDrop(micro.codice, 'micro')"
                              @click="articleDropMicroClick(micro.codice)"
                              class="
                                my-caps
                                d-flex
                                align-items-center
                                justify-content-between
                                flex-nowrap
                              "
                            >
                              <div class="sx">
                                <span>{{ micro.descrizione }}</span>

                              </div>
                              <img
                                class="freccina dx"
                                src="/media/icons/svg/freccina.svg"
                                alt=""
                              />
                            </a>

                            <!-- MENU CATEGORIE SOTTO MICRO-->
                            <ul
                              v-if="micro.codice == micro_menu"
                              class="sottomenu cat d-flex flex-column"
                              :style="catStyle"
                            >
                              <!-- TITOLO SOTTOMENU -->
                              <li
                                v-if="micro_menu === micro.codice"
                                :style="
                                  micro.codice == micro_menu
                                    ? 'background-color:  #efeeee;'
                                    : ''
                                "
                                class="
                                  d-flex
                                  justify-content-between
                                  align-items-center
                                  red
                                  noFreccia
                                  link-ret
                                  px16
                                "
                              >
                                <i
                                  v-if="width < 768"
                                  @mouseenter="articleDrop(micro.codice, 'micro')"
                                  @click="articleDropMicroClick('')"
                                  class="fas fa-angle-double-left"
                                ></i>

                                <a class="my-caps">
                                  <span class="level-four">{{ micro.descrizione }} </span>
                                </a>
                              </li>

                              <!-- CICLO CATEGORIE SOTTO MICRO -->
                              <li
                                v-for="cat in micro.categorie"
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                  link-ret
                                "
                              >
                                <a
                                  :href="
                                    url(
                                      '/b2b/category/' +
                                        family_menu +
                                        '/' +
                                        cat.codice
                                    )
                                  "
                                  class="
                                    my-caps
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    flex-nowrap
                                  "
                                >
                                  <div class="sx">
                                    <img
                                      class="icon"
                                      :src="
                                        url(
                                          '/storage/media/icons/svg/category/black/' +
                                            family_menu
                                              .replace('+', 'plus')
                                              .toLowerCase() +
                                            '-' +
                                            cat.codice.toLowerCase() +
                                            '.svg'
                                        )
                                      "
                                      alt="ico"
                                    />

                                    <!-- <img
                            v-else="famiglia.codice"
                            class="icon"
                            src="https://via.placeholder.com/300.png"
                            alt=""
                          /> -->
                                    <span>{{ cat.descrizione }}</span>
                                  </div>
<!--                                  <img-->
<!--                                    class="freccina dx"-->
<!--                                    src="/media/icons/svg/freccina.svg"-->
<!--                                    alt=""-->
<!--                                  />-->
                                </a>
                              </li>
                            </ul>
                          </li>

                          <!-- CICLO CATEGORIE SE NON CI SONO LE MICRO -->
                          <li
                            v-for="cat in famiglia.categorie"
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              link-ret
                            "
                          >
                            <a
                              :href="
                                url(
                                  '/b2b/category/' +
                                    family_menu +
                                    '/' +
                                    cat.codice
                                )
                              "
                              class="
                                my-caps
                                d-flex
                                align-items-center
                                justify-content-between
                                flex-nowrap
                              "
                            >
                              <div class="sx">
                                <img
                                  class="icon"
                                  :src="
                                    url(
                                      '/storage/media/icons/svg/category/black/' +
                                        family_menu
                                          .replace('+', 'plus')
                                          .toLowerCase() +
                                        '-' +
                                        cat.codice.toLowerCase() +
                                        '.svg'
                                    )
                                  "
                                  alt="ico"
                                />

                                <!-- <img
                            v-else="famiglia.codice"
                            class="icon"
                            src="https://via.placeholder.com/300.png"
                            alt=""
                          /> -->
                                <span>{{ cat.descrizione }}</span>
                              </div>
<!--                              <img-->
<!--                                class="freccina dx"-->
<!--                                src="/media/icons/svg/freccina.svg"-->
<!--                                alt=""-->
<!--                              />-->
                            </a>
                          </li>
                        </ul>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- CLICK ICONA LENTE -->
              <div v-show="isActiveMenu('gloabal_search')" class="float-block">
                <search @closed="onClickMenuNav()" />
                <div class="" @click="onClickMenuNav()"></div>
              </div>

              <!-- CLICK ICONA CARRELLO -->
              <div v-show="isActiveMenu('cart')" class="float-block float-cart">
                <cart
                  @onCloseCart="onClickMenuNav()"
                  :key="cartKey"
                  @numberItems="getNumberOfItems"
                />
              </div>
              <!-- ACQUISTO VELOCE-->
              <div
                v-show="isActiveMenu('acquisto-veloce')"
                class="float-block float-acquisto-v"
              >
                <acquisto-v :key="avKey" @closeAv="onClickMenuNav()" />
              </div>
              <div v-show="isActiveMenu('user')"></div>

              <!-- CLICK ICONA CARRELLO -->
              <!--              <div v-show="isActiveMenu('cart')" class="float-block cart-div">
                <cart @closeMe="onClickMenuNav('cart')"></cart>
              </div>-->

              <div
                id="out-menunavfloat"
                class="out-menunavfloat"
                @click="onClickMenuNav()"
              ></div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!--  menu-content-->
    <div
      v-if="opened_menu_nav === true"
      class="blur"
      @click="onClickMenuNav()"
    ></div>
  </div>
  <!-- app_menu -->
</template>

<script>

import search from "./search";

export default {
  components: {
    search,
  },

  data: function () {
    return {
      tree: null,
      macro: null,
      width: "",
      opened_menu_nav: false,
      float_name: "",
      mobile_menu: false,
      numCartItems: null,
      cartKey: 0,
      avKey: 0,
      acquistoVeloce: false,
      //apertura lista famiglie
      macro_menu: "",
      widthFamily: "",
      heightFamily: "",

      //apertura lista microfamiglie
      family_menu: "",
      widthMicro: "",
      heightMicro: "",

      //apertura lista categorie
      micro_menu: "",

      //grandezza finestre menu
      microStyle: "",
      catStyle: "",

      icons: [
        {
          img: "/media/icons/svg/icona-lente.svg",
          action: "gloabal_search",
          alt: "Ricerca prodotto",
        },
        {
          img: "/media/icons/svg/user.svg",
          action: "user",
          alt: "Opzioni account",
        },
        {
          img: "/media/icons/svg/cart1.svg",
          action: "cart",
          alt: "Carrello",
        },
      ],
    };
  },
  created: function () {
    this.width = $(window).width();
    $(window).resize(function (e) {
      this.width = $(window).width();
    });
  },
mounted() {
    this.treeLoad()
},
  watch: {
    "$store.state.cartKey": function () {
      this.cartKey = this.$store.state.cartKey;
    },
    "$store.state.avKey": function () {
      this.avKey = this.$store.state.avKey;
    },
    "$store.state.acquistoVeloce": function () {
      //console.log(this.$store.state.acquistoVeloce)
      if (this.$store.state.acquistoVeloce) {
        this.onClickMenuNav("acquisto-veloce");
      }
    },
    "$store.state.openedCart": function () {

      if (this.$store.state.openedCart) {
        this.onClickMenuNav("cart");

      } else {
        this.onClickMenuNav();
      }
    },
  },
  methods: {
    clickFamDesktop(codFam){
      return window.location.href = window.location.origin + '/b2b/family/' + codFam

    },
    getNumberOfItems: function (number) {
      this.numCartItems = number;
    },
    mobile_menuOn: function () {
      this.mobile_menu = !this.mobile_menu;
      if (this.mobile_menu === false) {
        this.macro_menu = "";
        this.family_menu = "";
        this.micro_menu = "";
        this.opened_menu_nav = false;
        this.float_name = "";
      }
    },
    articleDropMacroClick (code){
      if ($(window).width() <= 768){
        this.macro_menu = code
      }
    },
    articleDropFamilyClick (code){
      if ($(window).width() <= 768){
        this.family_menu = code
      } else if ($(window).width() > 900){
        this.clickFamDesktop(code)
      }
    },
    articleDropMicroClick (code){
      if ($(window).width() <= 768){
        this.micro_menu = code
      }
    },
    articleDrop: function (code, type) {
      if ($(window).width() > 768) {
        switch (type) {
          case "macro":
            if (this.macro_menu.length !== 0) {
              if (this.macro_menu === code) {
                this.macro_menu = "";
                this.family_menu = "";
                this.micro_menu = "";
              } else {
                this.macro_menu = code;
                this.family_menu = "";
                this.micro_menu = "";
              }
            } else {
              this.macro_menu = code;
            }
            break;

          case "family":
            this.width = $(window).width();
            this.widthFamily = $(".families").width();
            this.heightFamily = $(".families").height();

            if (this.width >= 768) {
              if (this.width < 1200) {
                this.microStyle = `top: 140px; left: ${this.widthFamily}px;`;
              } else {
                this.microStyle = `top: initial; left: ${this.widthFamily}px;`;
              }
            }

            if (this.family_menu.length !== 0) {
              if (this.family_menu === code) {
                this.family_menu = "";
                this.micro_menu = "";
              } else {
                this.family_menu = code;
                this.micro_menu = "";
              }

            } else {
              this.family_menu = code;
            }

            break;

          case "micro":
            this.width = $(window).width();
            this.widthMicro = $(".micros").width();
            this.heightMicro = $(".micros").height();
            this.widthFamily = $(".families").width();
            this.heightFamily = $(".families").height();

            if (this.width >= 768) {
              if (this.width < 1200) {
                this.catStyle = `top: 140px; left: ${this.widthMicro + this.widthFamily}px;`;
              } else {
                this.catStyle = `top: 0; left: ${this.widthMicro}px;`;
              }
            }

            if (this.micro_menu.length != 0) {
              if (this.micro_menu == code) {
                this.micro_menu = "";
              } else {
                this.micro_menu = code;
              }
            } else {
              this.micro_menu = code;
            }

            break;

          default:
            break;
        }
      }
    },
    treeLoad: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/filter',
      }).then(res => {
        this.tree = res.data.tree
      })
    },

    onClickMenuNav: function (name) {
      if (name === "user") {
        window.location.replace(window.location.origin + "/b2b/personal-area");
      } else {
        if (name && name !== this.float_name) {
          this.opened_menu_nav = true;
          //blocco dello scroll del document
          document.body.style.position = "fixed";
          document.body.style.top = `-${window.scrollY}px`;
          this.float_name = name;
        } else {
          this.opened_menu_nav = false;
          this.$store.commit("closeCart");
          //sblocco dello scroll del document
          document.body.style.position = "";
          document.body.style.top = "";
          this.$store.state.acquistoVeloce = false;
          this.$store.dispatch("refreshAv");
          this.float_name = "";
          //FACCIO CHIUDERE TUTTI I SOTTOMENU
          this.macro_menu = "";
          this.family_menu = "";
          this.micro_menu = "";
        }
      }
    },

    isActiveMenu: function (name = "") {
      return this.float_name === name;
    },

    closeMenu: function () {
      if (event.target.classList.contains("app-layer")) this.onClickMenuNav();
    },

    logout: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/logout",
      })
        .then((res) => {
          if (res.data.url) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => {
          vue.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        })
        .then(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: initial;
}
#app_menu.reserved {
  width: 100vw;
  height: var(--my-height-menu-reserved);
  background-color: var(--black-2);
  z-index: 10;
  position: fixed;
  top: 0;
}
.w-element-menu .wrap-logo {
  display: flex;
  align-items: center;
  height: 100%;
}
.w-element-menu .wrap-logo img {
  display: block;
}
#menu-nav {
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: auto;
  z-index: 2;
  background-color: var(--black-2);
  .w-element-menu {
    &.links-menu.desktop {
      display: none;
    }
    &.links-menu.mobile {
      display: block;
    }
  }
}

#menu-nav-float {
  position: absolute;
  z-index: 1;
  font-size: 14px;

  top: 80px;
  width: inherit;

  color: var(--black-2);
  &.product {
    left: 0;
    width: 100vw;
  }
  //.float-block.product {
  //  .my-caps {
  //    display: inline-block;
  //    &:first-letter {
  //      text-transform: uppercase;
  //    }
  //  }
  //}
}

#menu-nav-float .float-block {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--greenb2b);

  &.cart-div {
    position: fixed;
    right: 0;
  }
  &.float-acquisto-v {
    position: fixed;
    width: 100vw;
    left: 0;
    top: 80px;
    height: calc(100vh - 80px);
    @media (min-width: 768px) {
      width: 80vw;
    }
    @media (min-width: 992px) {
      width: 60vw;
    }
    @media (min-width: 1200px) {
      width: 50vw;
    }
  }
  &.product {
    .container {
      ul {
        li {
          padding: 0 15px;
          align-items: center!important;
          &.level-zero {
            align-items: baseline!important;
          }
          ul {
            font-size: 14px;
            li {
              margin-right: 0;
              a.macrofamiglie {
                text-align: center;
                text-decoration: underline!important;
              }
            }
          }
          a {
            &.macrofamiglie {
              width: 100%;
              display: flex!important;
              justify-content: center!important;
            }
            .level-one {
              margin-right: 3px;
            }
            .macro-caps {
              display: inline-block;
              text-transform: none;
            }
            .level-two {
              margin-left: 0!important;
              text-decoration: underline;
            }
            .level-three,.level-four {
              text-align: center;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}

#menu-nav-float .float-cart {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  width: 100vw; //  width: 50vw;

  justify-content: flex-start;
  backdrop-filter: blur(4px);
  position: fixed;
  right: 0;
  .outer {
    width: 100vw;
    height: 100vh;
  }
}

/* ---- Animation >>> ---- */
.menunavfloat-enter {
  opacity: 0;
  bottom: 0;
  background-color: var(--greenb2b);
}

.menunavfloat-enter-to {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0);
}

.menunavfloat-enter-active {
  transition: all 0.4s ease-out;
}

.menunavfloat-leave {
  opacity: 1;
  bottom: -100vh;
}
.menunavfloat-leave-to {
  opacity: 0;
  bottom: 0;
}

.menunavfloat-leave-active {
  transition: all 0.4s ease-out;
}

/* ---- <<<< Animation ---- */
#out-menunavfloat {
  width: 100%;
  height: 100%;
}

#menu-nav .w-link-list ul {
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
}
#menu-nav .w-link-list ul li {
  cursor: pointer;
  padding: 0 16px;
  margin-left: 0;
  a:hover {
    color: inherit;
  }
}

/*#menu-nav .w-link-list ul li.option::after {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border: 1px solid white;
  transform: rotate(-45deg);
  margin-left: 10px;
  top: -2px;
  border-top: none;
  border-right: none;
  position: relative;
  transition: all 0.2s ease;
  margin-top: 10px;
}*/

//#menu-nav .w-link-list ul li.option.active::after {
//  transform: rotate(45deg) rotateX(180deg);
//}
#menu-nav .w-link-list ul li.option {
  align-items: center;
  svg {
    margin-left: 15px;
    path {
      transform: scale(0.9);
      fill: white;
    }
  }
  &.active svg {
    transform: rotate(180deg);
  }
}
#app_menu.reserved #menu-nav-float ul {
  list-style-type: none;
  margin: auto;
  padding: 0;
  display: flex;
  max-width: 1200px;
}
#app_menu.reserved #menu-nav-float ul li {
  cursor: pointer;
  max-width: 600px;
  //padding: 0 15px;
  //padding-right: 15px;
  display: flex;
  align-items: baseline;
  position: relative;

  .sottomenu {
    align-items: center;
    i.fa-angle-double-left {
      margin-right: 10px;
    }
    font-size: 12px;
    background-color: #fff;
    position: fixed;
    &.families {
      width: 100vw;
      left: 0;
      bottom: 0;
      height: 85vh;
      z-index: 1;
      li {
        &:hover {
          background-color: #f6f6f6;
        }
        &.lightgrey {
          background-color: #f6f6f6;
        }
        a {
          .sx {
            display: flex;
            span {
              font-size: 14px;
            }
          }
          span {
            align-self: center;
            margin-left: 30px;
          }
          @media (max-width: 768px) {
            padding: 0;
            margin: 20px 0;
          }
        }
      }
    }
    &.micros {
      left: 0;
      top: initial; //top: 0;
      height: 85vh; //togliere
      background-color: #f6f6f6;
      li {
        &:hover {
          background-color: #efeeee;
        }
        &.lightgrey {
          background-color: #efeeee;
        }
      }
      width: 100vw;
    }

    &.cat {
      z-index: 1;
      position: absolute;
      top: 0;
      height: 85vh;

      background-color: #efeeee;
      li {
        background-color: #efeeee;

        &:hover {
          background-color: #d6d4d4;
        }
        &.lightgrey {
          background-color: #efeeee;
        }
      }

      width: 100vw;
      left: 0;
    }

    li {
      position: initial;

      &.px16 {
        font-size: 16px;
        height: 80px;
      }
      height: 38px; //60px
      width: 100%;
      border: none;
      //border: 1px solid black;

      a {
        width: 100%;
        img.icon {
          height: 36.5px;
          width: 36.5px;
        }
        span {
          margin-left: 31px;
        }
        img.freccina {
          padding-left: 31px;
        }
      }
      &::after {
        border: none;
      }
      &:hover {
        border: none;
        box-shadow: none;
      }
    }
  }

  &:after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border: 1px solid;
    transform: rotate(-45deg);
    // margin-left: 10px;
    top: -2px;
    border-top: none;
    border-left: none;
    position: relative;
    transition: all 0.2s ease;
    margin-top: 10px;
    margin-left: 3px;
  }

  &.noFreccia {
    background-color: #fff;
    &:after {
      transform: rotate(45deg);
    }
  }

  &:hover {
    background-color: #fff;
  }
}
#app_menu.reserved #menu-nav-float ul li a {
  color: inherit;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  text-transform: lowercase;
  &.my-caps {
    display: inline-block;
    &:first-letter {
      text-transform: uppercase;
    }
  }
}

.w-element-menu .w-icons {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
}

.w-element-menu .w-icons .icon {
  width: 20px;
  height: 20px;
  margin: 0 1em;
  position: relative;
  .badge-cart {
    padding: 0;
    border-radius: 50%;
    background-color: rgba(255, 0, 0, 0.99);
    color: #ffffff;
    width: 17px;
    height: 17px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    font-weight: bold;
    right: -10px;
    top: -8px;
  }
}
.w-element-menu .w-icons .icon:first-child {
  margin: 0 1em 0 0;
}
.w-element-menu .w-icons .icon:last-child {
  margin: 0 0 0 1em;
}
.w-element-menu .w-icons .icon img {
  width: inherit;
  height: auto;
  display: block;
}

// MY CUSTOM
#menu-nav {
  .w-element-menu {
    &.links-menu {
      position: absolute;
      top: 79px;
      background: var(--black-2);
      border: none;
      left: 0;
      width: 100vw;
      .w-link-list {
        ul {
          flex-direction: column;
          align-items: center;
          li {
            padding-top: 10px;
            padding-bottom: 10px;
          }
        }
      }
    }
    .w-icons {
      height: auto;
      .icon {
        margin: 0 20px;

        height: 20px;
        width: auto;
        &:hover {
          cursor: pointer;
        }
        img {
          height: 20px;
        }
      }
    }
    .w-logout {
      .red {
        img {
          height: 20px;
        }
        &:hover {
          color: #ff0044;
          text-decoration: underline;
        }
      }
    }
  }
}

#menu-nav-float {
  left: 0;
  width: 100vw;
  top: 80px;
  &.product {
    top: 252px;
   @media (max-width: 576px){
     top: 210px;
   }
    ul {
      flex-direction: column;
      align-items: center;
    }
  }

}

.blur {
  position: fixed;
  bottom: 0;
  left: 0;
  //background-color: rgba($color: #26262a, $alpha: 0.53);
  //backdrop-filter: blur(10px);
  background-color: transparent;

  backdrop-filter: blur(24px);
  width: 100vw;
  height: calc(100vh - 250px);
}
.w-logout {
  .text {
    white-space: nowrap;
    display: none;
  }
}

@media screen and (min-width: 768px) {
  #menu-nav {
    .w-element-menu {
      &.links-menu {
        position: initial;
        width: unset;
        display: inline-block;
        &.desktop {
          display: flex;
        }
        &.mobile {
          display: none;
        }

        .w-link-list {
          ul {
            flex-direction: row;
            li {
              padding-top: 0;
              padding-bottom: 0;
            }
          }
        }
      }
    }
  }

  .w-element-menu {
    &.links-menu.desktop {
      display: block;
    }
    &.links-menu.mobile {
      display: none;
    }
  }

  .icon.hamburger {
    display: none;
  }
  #app_menu.reserved #menu-nav-float ul li .sottomenu.families {
    top: 140px;
    width: 27%;
    height: initial;
    bottom: initial;

  }
  #app_menu.reserved #menu-nav-float ul li .sottomenu.micros {
    top: 0;
    height: initial;
    width: 337px;
  }
  #app_menu.reserved #menu-nav-float ul li .sottomenu.cat {
    position: fixed;
    top: initial;
    height: auto;
    width: 337px;
  }
  #menu-nav-float {
    &.product {
      top: 80px;

      ul {
        flex-direction: row;
      }
    }
  }
  .blur {
    height: calc(100vh - 80px);
  }
}

@media screen and (min-width: 992px) {
  #app_menu.reserved #menu-nav-float ul li .sottomenu {
    li {
      &.px16 {
        font-size: 16px;
        height: 80px;
      }
      height: 60px;
      width: 100%;
      border: none;

      a {
        width: 100%;
        img.icon {
          height: 36.5px;
        }
        span {
          margin-left: 20px;
          display: inline-block;
          &:first-letter {
            text-transform: uppercase;
          }
        }
        img.freccina {
          padding-left: 31px;
        }
      }
      &::after {
        border: none;
      }
      &:hover {
        border: none;
        box-shadow: none;
      }
    }
  }
  #menu-nav .w-element-menu .w-icons .icon {
    margin: 0 25px;
  }
  #menu-nav {
    .w-element-menu {
      .w-link-list {
        ul {
          li {
            margin-left: 50px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  #app_menu.reserved #menu-nav-float ul li .sottomenu {
    position: absolute;
    &.families {
      width: 130%;
      top: 61px;
      height: fit-content;
    }
    &.micros {
      min-height: 100%;
      width: 337px;
      top: initial;
    }

    &.cat {
      min-height: 100%;
      width: 365px;
      position: absolute;
    }
  }
  #menu-nav-float .float-cart {
    width: 60vw;
  }

  .blur {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: rgba($color: #26262a, $alpha: 0.53);
    backdrop-filter: blur(10px);
    width: 100vw;
  }
  #menu-nav .w-element-menu .w-icons .icon {
    margin: 0 42.5px;
  }

  .w-logout {
    .text {
      white-space: nowrap;
      display: inline-block;
    }
  }
}
</style>
